import { render, staticRenderFns } from "./TopFooterLinks.vue?vue&type=template&id=2073cb38&scoped=true&"
import script from "./TopFooterLinks.vue?vue&type=script&lang=js&"
export * from "./TopFooterLinks.vue?vue&type=script&lang=js&"
import style0 from "./TopFooterLinks.vue?vue&type=style&index=0&id=2073cb38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2073cb38",
  null
  
)

export default component.exports